const hasSlider = document.querySelector('.js-team__slider .swiper');

if (hasSlider) {
	Promise.all([
		import('swiper'),
		import(
			/* webpackExports: ["Navigation"] */
			'swiper/modules'
		),
	])
		.then(([{ default: Swiper }, { Navigation }]) => {
			const swiper = new Swiper('.js-team__slider .swiper', {
				slidesPerView: 'auto',
				navigation: {
					prevEl: '.js-team__slider-arrow-left',
					nextEl: '.js-team__slider-arrow-right',
				},
				modules: [Navigation],
			});
		})
		.catch((err) => console.error(err));
}
